module.exports = __webpack_public_path__ + "img/smile-active.54503423.svg";